import { Grid, Divider } from '@mui/material'
import DatePicker from '../../../../../../shared/UI/DatePicker'
import { RtwMaintenanceRequest } from '../../../../../../types/return-to-work'

type Props = {
  returnDate: string
  onDateChange: (field: keyof RtwMaintenanceRequest, value: any) => void
}

function ReturnDateSection({ returnDate, onDateChange }: Props) {
  return (
    <Grid item xs={12} mt={5}>
      <DatePicker
        label="Return to work date"
        value={new Date(returnDate)}
        onChange={(newDate) => onDateChange('returnDate', newDate)}
      />
      <Divider sx={{ margin: '30px 0', paddingTop: '8px' }} />
    </Grid>
  )
}

export default ReturnDateSection